import React, { useState } from "react";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { SmallArrowIcon } from "@/assets/icons";
import Button from "@/ui/Button/Button";
import ContainerLoader from "@/ui/ContainerLoader/ContainerLoader";
import { useUserDataContext } from "@/store/UserProvider";
import { usePaymentOptionStore } from "@/store/paymentOption";
import { setActivateOption, setPaymentMethod } from "@/api/user";
import { showNotification } from "@/utils/network";
import { useTranslation } from "react-i18next";
import { useChoosePaymentOptionsContext } from "./ChoosePaymentOptionsContext";
import cls from "./styles.module.scss";

export function ConfirmPaymentOptionPage() {
  const { t } = useTranslation();
  const { user, setPaymentOption } = useUserDataContext();
  const { goToStep } = usePaymentOptionStore();
  const { newOption, goBack } = useChoosePaymentOptionsContext();
  const [isLoading, setIsLoading] = useState(false);

  const changePaymentOption = async () => {
    if (!user) return;

    setIsLoading(true);

    try {
      if (newOption === "orders") {
        await setActivateOption({
          telegram_id: user.telegram_id,
          option: newOption,
        });
      } else {
        await setPaymentMethod({
          payment_method_id: newOption,
        });
      }

      setPaymentOption(newOption);
      goToStep("firstPage");
      showNotification({
        type: "success",
        text: t("paymentOptions.changedPaymentOption"),
      });
    } catch (e) {
      console.log(e);
      goBack();
      showNotification({
        type: "error",
        text: t("paymentOptions.unableToChangePaymentOption"),
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FlexColumn gap={24} className={cls.paymentOptionBlock}>
      <button type="button" className={cls.btnArrow} onClick={goBack}>
        <SmallArrowIcon />
      </button>
      <Typography className={cls.heading}>
        {t("paymentOptions.changePaymentOption")}
      </Typography>
      <Typography className={cls.desc}>
        {newOption === "orders"
          ? t("paymentOptions.changeSubscriptionToOrders")
          : t("paymentOptions.changeSubscriptionToCard", {
              price: user?.subscription_price,
            })}
      </Typography>
      <div className={cls.confirmBtn}>
        {!isLoading ? (
          <Button onClick={changePaymentOption} label={t("common.confirm")} />
        ) : (
          <ContainerLoader />
        )}
      </div>
    </FlexColumn>
  );
}
